import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Cookies from "universal-cookie";

import {
  LifeSafer,
  Monitech,
  Guardian,
  QuickStart,
} from "../_helpers/BrandConstants";
import { USA, Australia } from "@/_helpers/CountryConstants";

export const Policies = () => {
  const { t } = useTranslation();
  const [termsOfUseWebiste, setTermsOfUseWebiste] = useState();
  const [privacyWebsite, setPrivacyWebite] = useState();
  const [cookiesWebsite, setCookiesWebsite] = useState();
  const [qualityWebsite, setQualityWebsite] = useState();
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const siteCountry = cookies.get("siteCountry") || USA;

  useEffect(() => {
    if (brand === LifeSafer && siteCountry === USA) {
      setTermsOfUseWebiste("https://www.lifesafer.com/terms-of-use/");
      setPrivacyWebite("https://www.lifesafer.com/privacy-policy/");
      setCookiesWebsite("https://www.lifesafer.com/cookie-policy/");
      setQualityWebsite("https://www.lifesafer.com/quality-policy/");
    } else if (brand === LifeSafer && siteCountry === Australia) {
      setTermsOfUseWebiste("https://www.lifesafer.au/terms-of-use/");
      setPrivacyWebite("https://www.lifesafer.au/privacy-policy/");
      setCookiesWebsite("https://www.lifesafer.au/cookie-policy/");
      setQualityWebsite("https://www.lifesafer.au/quality-policy/");
    } else if (brand === Guardian) {
      setTermsOfUseWebiste("https://www.guardianinterlock.com/terms-use/");
      setPrivacyWebite("https://www.guardianinterlock.com/privacy/");
      setCookiesWebsite("https://www.guardianinterlock.com/");
      setQualityWebsite("https://www.guardianinterlock.com/");
    } else if (brand === Monitech) {
      setTermsOfUseWebiste("https://monitechnc.com/");
      setPrivacyWebite("https://monitechnc.com/privacy-policy/");
      setCookiesWebsite("https://monitechnc.com/");
      setQualityWebsite(
        "https://monitechnc.com/about-monitech-ignition-interlock/"
      );
    } else if (brand === QuickStart) {
      setTermsOfUseWebiste("https://www.quickstartaz.com/");
      setPrivacyWebite("https://www.quickstartaz.com/");
      setCookiesWebsite("https://www.quickstartaz.com/");
      setQualityWebsite("https://www.quickstartaz.com/");
    } else {
      setTermsOfUseWebiste("https://www.lifesafer.com/terms-of-use/");
      setPrivacyWebite("https://www.lifesafer.com/privacy-policy/");
      setCookiesWebsite("https://www.lifesafer.com/cookie-policy/");
      setQualityWebsite("https://www.lifesafer.com/quality-policy/");
    }
  }, [brand, siteCountry]);

  return (
    <Typography variant="body2" align="center">
      <Link
        color="inherit"
        href={termsOfUseWebiste}
        target="_blank"
        rel="noopener noreferrer"
        style={{ paddingRight: 15 }}
      >
        {t("policies.termsofUseLabel")}
      </Link>
      <Link
        color="inherit"
        href={privacyWebsite}
        target="_blank"
        rel="noopener noreferrer"
        style={{ paddingRight: 15 }}
      >
        {t("policies.privacyLabel")}
      </Link>

      <Link
        color="inherit"
        href={cookiesWebsite}
        target="_blank"
        rel="noopener noreferrer"
        style={{ paddingRight: 15 }}
      >
        {t("policies.cookiesLabel")}
      </Link>

      <Link
        color="inherit"
        href={qualityWebsite}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("policies.qualityLabel")}
      </Link>
    </Typography>
  );
};
